var map = {
	"./beer.png": 1139,
	"./hot-beverages.png": 9878,
	"./juices-fresh-waters.png": 8014,
	"./margaritas.png": 5909,
	"./sodas.png": 9763,
	"./specialty-cocktails.png": 2884,
	"./tequila.png": 2313,
	"./whiskey.png": 6093,
	"./wine.png": 3498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 759;